<header-actions style="margin:0.3em 0.5em">
  <h4 style="margin:0">Select Site Location</h4>
  <button mat-dialog-close mat-flat-button>cancel</button>
  <button [mat-dialog-close]="marker.getLngLat()" color="primary" mat-flat-button>select</button>
</header-actions>

<mat-dialog-content style="max-height: unset; padding: 0">
  <div #mapContainer style="height:100%"></div>
</mat-dialog-content>
